// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import myAccountFilterSectionStyles from "@sc/App/SharedStyles/MyAccountPages/List/MyAccountFilterSectionStyles";
import { filterStyles } from "@sc/Overrides/Widgets/InvoiceHistory/InvoiceHistoryFilter";
import { hideElement, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

filterStyles.container = {
    ...myAccountFilterSectionStyles.filterContainer,
};

filterStyles.headingItem = {
    css: css`
        ${hideElement}
    `,
};

filterStyles.clearFiltersButton = {
    ...myAccountFilterSectionStyles.clearButton,
};

filterStyles.buttonsItem = {
    width: [12, 12, 12, 9, 9],
    css: css`
        &&& {
            margin-left: auto;
            justify-content: flex-end;
            align-items: flex-end;
        }
    `,
};

filterStyles.onlyOpenGridItem = {
    width: [12, 12, 12, 3, 3],
    align: "middle",
    css: css`
        > div {
            ${xScreen("lte", "md")} {
                margin-top: 0;
            }
        }
    `,
};

filterStyles.shipToGridItem = {
    width: [12, 12, 12, 2, 2],
};

filterStyles.invoiceNumberGridItem = {
    width: [12, 12, 12, 2, 2],
};

filterStyles.orderNumberGridItem = {
    width: [12, 12, 12, 2, 2],
};

filterStyles.poNumberGridItem = {
    width: [12, 12, 12, 2, 2],
};

filterStyles.fromGridItem = {
    width: [6, 6, 6, 2, 2],
    css: css`
        width: 100%;
        display: flex;
        > div {
            width: 100%;
            display: flex;
        }
    `,
};
filterStyles.toGridItem = {
    width: [6, 6, 6, 2, 2],
    css: css`
        > div {
            width: 100%;
            display: flex;
        }
    `,
};

filterStyles.fromDate = {
    ...myAccountFilterSectionStyles.fromDate,
};

filterStyles.toDate = {
    ...myAccountFilterSectionStyles.toDate,
};

filterStyles.appliedFiltersContainer = {
    ...myAccountFilterSectionStyles.appliedFiltersContainer,
};

filterStyles.appliedFilterTag = {
    ...myAccountFilterSectionStyles.appliedFilterTag,
};
